import {FeatureNs} from "@shared/types/feature.namespace";

export namespace BoardsNs {

    /** Editor Routes */
    export enum BoardsRouteEnums {
        BOARDS = 'Boards',
        FEATURE = 'BoardsFeature',
        FEATURE_SELECTED = 'BoardsFeatureSelected',
        PAGE_SELECTED = 'BoardsFeaturePageSelected',
        SCREEN = 'BoardsScreen',
        SCREEN_SELECTED = 'BoardsScreenSelected',
        APP_DETAILS = 'BoardsApplication',
        ESTIMATION = 'BoardsEstimation',
        SOURCES = 'BoardsSources',
    }

    export interface Breadcrumb {
        id: string,
        summary: string,
        type: FeatureNs.FeatureTypeEnums,
    }

    export interface RecentlyViewedItem {
        id: string,
        type: string,
        summary: string,
        color: string,
    }

    export interface RecentlyViewed {
        projectId: string,
        features: RecentlyViewedItem[],
        screens: RecentlyViewedItem[],
    }

    export interface AIResult {
        root: string,
        descriptions: string[],
        features: any[],
        modules: any[],
        appDetails: AIAppDetails,
    }

    export interface AIAppDetails {
        TechVertical: string[],
        ApplicationType: any[],
        TargetBranch: any[],
        ApplicationSpecification: any[],
        ApplicationUser: any[],
        DeviceType: any[],
        TechStack: AITechStackDetails,
        BusinessModel: any[],
        Persona: any[],
        TargetGroup: any[],
    }

    export interface AITechStackDetails {
        Backend: string[],
        Frontend: any[],
        Database: any[]
    }

    export interface AIBalanceInfo {
        remainingBalance: number,
        totalBalance: number,
    }

    export interface AISearchResult {
        balanceInfo: AIBalanceInfo,
        searchResult: AIResult,
    }

    export enum AISearchType {

        // APPLICATION MODULES
        APPLICATION_DETAILS_PART1 = 'APPLICATION_DETAILS_PART1',
        APPLICATION_DETAILS_PART2 = 'APPLICATION_DETAILS_PART2',
        APPLICATION_DETAILS_PART3 = 'APPLICATION_DETAILS_PART3',

        // PAGES
        PROBLEM_SOLUTION = 'PROBLEM_SOLUTION',
        PROBLEM_SOLUTION_PRO = 'PROBLEM_SOLUTION_PRO',

        PROJECT_DESCRIPTION_BASIC = 'PROJECT_DESCRIPTION_BASIC',
        PROJECT_DESCRIPTION_DETAILED = 'PROJECT_DESCRIPTION_DETAILED',
        TARGET_GROUP_ANALYSIS = 'TARGET_GROUP_ANALYSIS',
        LIST_STAKEHOLDER = 'LIST_STAKEHOLDER',
        SWOT_ANALYSIS = 'SWOT_ANALYSIS',
        USE_CASE_ANALYSIS = 'USE_CASE_ANALYSIS',
        MARKET_ANALYSIS = 'MARKET_ANALYSIS',
        BUSINESS_MODEL_ANALYSIS = 'BUSINESS_MODEL_ANALYSIS',
        PROJECT_DEPENDECY = 'PROJECT_DEPENDECY',
        PRODUCT_VISION = 'PRODUCT_VISION',
        NON_FUNCTIONAL_REQ = 'NON_FUNCTIONAL_REQ',


        // TREE
        RELATED_FEATURE = 'RELATED_FEATURE',
        SUB_FEATURE = 'SUB_FEATURE',
        GROUP_RLT_TREE = 'GROUP_RLT_TREE',
        LIST_MODULE_TREE = 'LIST_MODULE_TREE',
        GROUP_SUB_TREE = 'GROUP_SUB_TREE',
        FEATURE_RLT_TREE = 'FEATURE_RLT_TREE',
        FEATURE_SUB_TREE = 'FEATURE_SUB_TREE',
        SUBFEATURE_RTL_TREE = 'SUBFEATURE_RTL_TREE',


        // FEATURE PAGE
        WRITE_DESCRIPTION = 'WRITE_DESCRIPTION',
        GROUP_DESCRIPTION = 'GROUP_DESCRIPTION',
        FEATURE_DESCRIPTION = 'FEATURE_DESCRIPTION',
        SUB_FEATURE_DESCRIPTION = 'SUB_FEATURE_DESCRIPTION',
        FEATURE_USE_CASE = 'FEATURE_USE_CASE',

        USER_STORY_CLASSIC = 'USER_STORY_CLASSIC',
        USER_STORY_BDD = 'USER_STORY_BDD',
        USER_STORY_BDD_SCENARIOS = 'USER_STORY_BDD_SCENARIOS',
        USER_STORY_JOB = 'USER_STORY_JOB',
        USER_STORY_3CARD = 'USER_STORY_3CARD',
        USER_STORY_INVEST = 'USER_STORY_INVEST',
        USER_STORY_5W1H = 'USER_STORY_5W1H',
        USER_STORY_SAFE = 'USER_STORY_SAFE',

        ACCEPTANCE_CRITERIA_BASIC = 'ACCEPTANCE_CRITERIA_BASIC',
        ACCEPTANCE_CRITERIA_BDD = 'ACCEPTANCE_CRITERIA_BDD',
        ACCEPTANCE_CRITERIA_CHECKLIST = 'ACCEPTANCE_CRITERIA_CHECKLIST',
        ACCEPTANCE_CRITERIA_PERSONA = 'ACCEPTANCE_CRITERIA_PERSONA',
        ACCEPTANCE_CRITERIA_VALUE = 'ACCEPTANCE_CRITERIA_VALUE',
        ACCEPTANCE_CRITERIA_EXAMPLE = 'ACCEPTANCE_CRITERIA_EXAMPLE',
        ACCEPTANCE_CRITERIA_GOAL = 'ACCEPTANCE_CRITERIA_GOAL',
        ACCEPTANCE_CRITERIA_DOD = 'ACCEPTANCE_CRITERIA_DOD',

        TEST_CASE_BASIC = 'TEST_CASE_BASIC',
        TEST_CASE_BDD = 'TEST_CASE_BDD',
        TEST_CASE_USE_CASE = 'TEST_CASE_USE_CASE',
        TEST_CASE_BOUNDARY_VALUE = 'TEST_CASE_BOUNDARY_VALUE VALUE',
        TEST_CASE_EXPLORATORY = 'TEST_CASE_EXPLORATORY',
        TEST_CASE_DECISION_TABLE = 'TEST_CASE_DECISION_TABLE',
        TEST_CASE_STATE_TRANSITION = 'TEST_CASE_STATE_TRANSITION',
        TEST_CASE_NEGATIVE = 'TEST_CASE_NEGATIVE',
        TEST_CASE_SAFE = 'TEST_CASE_SAFE',

        // APPLICATION MODULES
        NO_CODE_INITIAL = 'NO_CODE_INITIAL',
        NO_CODE_SEQUENTIAL = 'NO_CODE_SEQUENTIAL',

        // SCREEN
        SCREEN_CREATE_PLACEHOLDER = 'SCREEN_CREATE_PLACEHOLDER',
        SCREEN_EXTRACT_FEATURE = 'SCREEN_EXTRACT_FEATURE',

    }

    export interface AISearchRequest {
        workspaceId: string,
        projectId: string,
        query: string,
        type: AISearchType,
    }

}
